const theme = {
    colors: {
      teal: "#E8F4F5",
      white: "#FFF",
      titles: "#306773",
      button: "#306773",
      beje: "#F8F4EC",
      footer: "#234F59", 
      p: "#4D535C" 
    }
}

export default theme;